export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.aab3cded3420d5d0e921e75893305d43.css";